export enum ProjectFileTemplate {
  Empty,
  NewTopic,
  TopicForEndnotes,
  TopicForGlossary,
  TopicForIndex,
  TopicForListOfConcepts,
  TopicForListOfElements,
  TopicForListOfImages,
  TopicForListOfTables,
  TopicForMiniTOC,
  TopicForTOC,
  Snippet,
  TemplatePage,
  ConditionTagSet,
  VariableSet,
  Stylesheet,
  BrandingStylesheet,
  Target,
  Toc,
  Destination,
  Project,
}
